module.exports = __webpack_public_path__ + "static/media/888-dragons.d40bdaa5.gif";